// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { getShipToState } from "@insite/client-framework/Store/Data/ShipTos/ShipTosSelectors";
import McMcApplicationState from "@mcmc/App/Store/McMcApplicationState";
import cloneDeep from "lodash/cloneDeep";

type HandlerType = Handler<{ overrideShipTo: boolean }>;

export const SetOverrideShipTo: HandlerType = props => {
    const state = props.getState() as McMcApplicationState;
    const { cartId } = state.pages.checkoutShipping;
    const cart = cartId ? getCartState(state, cartId).value : getCurrentCartState(state).value;
    const shipToState = getShipToState(state, cart ? cart.shipToId : undefined);
    const overrideAddress = cart?.properties.overrideShipToAddress
        ? { ...JSON.parse(cart?.properties.overrideShipToAddress) }
        : undefined;
    const shipToAddress = shipToState.value ? cloneDeep(shipToState.value) : {};

    props.dispatch({
        type: "CustomCheckoutShipping/SetOverrideShipTo",
        overrideShipTo: props.parameter.overrideShipTo,
        address: props.parameter.overrideShipTo ? overrideAddress || shipToAddress : undefined,
    } as any);
};

export const chain = [SetOverrideShipTo];

const setOverrideShipTo = createHandlerChainRunner(chain, "SetOverrideShipTo");
export default setOverrideShipTo;
